// extracted by mini-css-extract-plugin
export default {"unavailablePill":"UnavailableMentionPill_unavailablePill__YShso","icon":"UnavailableMentionPill_icon__tApdM"};